module.exports = __webpack_public_path__ + "img/solution-mask.7b9d9062.png";